import { combineReducers } from "redux";
import camada from "./camada/reducer";
import panorama from "./panorama/reducer";

export const mapa = combineReducers({
  camada,
  panorama
});
